module.exports = __webpack_public_path__ + "static/media/HCMM222.f64721c4.jpg";